<template>
  <div id="navi_menu">
    <v-app-bar app dense clipped-left dark color="light-blue darken-3">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title @click.stop="move()" class="logo">
        ERP Value
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu left bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>fas fa-user-cog</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item @click="passDialog = true">
            <v-list-item-avatar>
              <v-icon>fas fa-key</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>バスワード変更</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="emailDialog = true">
            <v-list-item-avatar>
              <v-icon>fas fa-envelope</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>メールアドレス変更</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-avatar>
              <v-img :src="require('@/assets/logout.png')"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>ログアウト</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <template v-slot:prepend v-if="getMyself()">
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-subtitle>ようこそ</v-list-item-subtitle>
            <v-list-item-title>{{ getMyself().name }} さん</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-list dense v-if="roles.length > 0">
        <v-list-item to="/" link>
          <v-list-item-avatar>
            <v-img :src="require('@/assets/dashboard.png')"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>ダッシュボード</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- 各種メニュー -->
        <template v-for="item in $router.options.routes">
          <template v-if="item.meta.bashboard">
            <div :key="item.name" v-if="isBlockAllowed(item.children)">
              <v-divider></v-divider>
              <v-subheader>{{ item.name }}</v-subheader>
              <template v-for="scene in item.children">
                <v-list-item v-if="isAllowed(scene.name)" :key="scene.name" :to="scene.path" link>
                  <v-list-item-avatar>
                    <v-img :src="scene.meta.icon"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ scene.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </div>
          </template>
        </template>
      </v-list>
    </v-navigation-drawer>

    <!-- パスワード変更ダイアログ -->
    <v-navigation-drawer v-model="passDialog" width="600" class="edit-dialog" fixed temporary right stateless>
      <v-card flat>
        <v-card-title class="dialog-header">
          <span class="title font-weight-light">パスワードの変更</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="passValid">
            <v-row no-gutters>
              <v-col cols="12" class="pa-2">
                <v-text-field
                  ref="oldPass"
                  label="現在のパスワード"
                  v-model="oldPass"
                  type="password"
                  class="required"
                  :rules="[rules.required, rules.min8Char]"
                  autocomplete="oldPass"
                  outlined hide-details="auto">
                </v-text-field>
              </v-col>
              <v-col cols="12" class="pa-2">
                <v-text-field
                  ref="newPass1"
                  label="新しいパスワード"
                  v-model="newPass1"
                  type="password"
                  class="required"
                  :rules="[rules.required, rules.min8Char]"
                  autocomplete="newPass1"
                  outlined hide-details="auto">
                </v-text-field>
              </v-col>
              <v-col cols="12" class="pa-2">
                <v-text-field
                  ref="newPass2"
                  label="パスワードの確認"
                  v-model="newPass2"
                  type="password"
                  class="required"
                  :rules="[rules.required, rules.min8Char, passExect]"
                  autocomplete="newPass2"
                  outlined  hide-details="auto">
                </v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="dialog-footer">
          <v-btn color="primary" @click="passChange" :disabled="!passValid" text>
            <v-icon left>fas fa-save</v-icon>更新
          </v-btn>
          <v-btn @click="passDialog = false" text>
            <v-icon left>fas fa-times</v-icon>キャンセル
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-navigation-drawer>

    <!-- メールアドレス変更ダイアログ -->
    <v-navigation-drawer v-model="emailDialog" width="600" class="edit-dialog" fixed temporary right stateless>
      <v-card flat>
        <v-card-title class="dialog-header">
          <span class="title font-weight-light">メールアドレスの変更</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="emailValid">
            <v-row no-gutters>
              <v-col cols="12" class="pa-2">
                <v-text-field
                  ref="newEmail1"
                  label="新しいメールアドレス"
                  v-model="newEmail1"
                  type="email"
                  class="required"
                  :rules="[rules.required, rules.email]"
                  outlined hide-details="auto">
                </v-text-field>
              </v-col>
              <v-col cols="12" class="pa-2">
                <v-text-field
                  ref="newEmail2"
                  label="メールアドレスの確認"
                  v-model="newEmail2"
                  type="email"
                  class="required"
                  :rules="[rules.required, rules.email, emailExect]"
                  outlined  hide-details="auto">
                </v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="dialog-footer">
          <v-btn color="primary" @click="emailChange" :disabled="!emailValid" text>
            <v-icon left>fas fa-save</v-icon>更新
          </v-btn>
          <v-btn @click="emailDialog = false" text>
            <v-icon left>fas fa-times</v-icon>キャンセル
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-navigation-drawer>

    <!-- loading -->
    <v-fade-transition>
      <v-container v-if="mainte" class="mainte-mask" fluid fill-height>
        <v-layout align-center justify-center>
          <div class="wrap">
            <v-img :src="require('@/assets/mainte.png')" width="200" class="mx-auto"></v-img>
            <div class="message-main">
              ただいまバージョンアップに伴い<br>
              メンテナンスを行っております。
            </div>
            <div class="message-sub">
              「更新する」ボタンを押してもこの画面が出る場合は<br>
              ご不便をお掛けしますがしばらくたってから<br>
              ご利用いただけますようお願い申し上げます。
            </div>
            <v-btn @click.stop="reload" outlined color="lime">
              <v-icon left>fas fa-sync-alt</v-icon>
              更新する
            </v-btn>
          </div>
        </v-layout>
      </v-container>
    </v-fade-transition>
  </div>
</template>

<script>
import { Auth, API, graphqlOperation } from 'aws-amplify'
import { getUser, listRoles } from '../graphql/queries'
import { updateUser } from '../graphql/mutations'
import fetch from 'node-fetch'

export default {
  data: () => ({
    drawer: null,
    passDialog: false,
    emailDialog: false,
    passValid: true,
    emailValid: true,
    oldPass: null,
    newPass1: null,
    newPass2: null,
    newEmail1: null,
    newEmail2: null,
    roles: [],
    current_ver: require('../../package.json').version,
    verCheck: null,
    refresh: false,
    mainte: false,
  }),
  props: {},
  mounted: async function() {
    try {
      //ログインユーザーを取得
      const user = await Auth.currentUserInfo()
      const myself = await API.graphql(graphqlOperation(getUser, {id: user.username }))
      if (myself.data.getUser.enabled) {
        //storeにユーザー情報を格納
        this.$store.dispatch('updateMyself', Object.assign({
          name: myself.data.getUser.last + ' ' + myself.data.getUser.first,
        }, myself.data.getUser))
      } else {
        throw 'ご利用いただけません'
      }
      //roles query
      await this.getRoles()

    } catch(error) {
      //console.log(error)
      await Auth.signOut()
      this.$router.push('/login')
    }
  },
  created() {
    this.versionCheck()
    if (!this.verCheck) this.verCheck = setInterval(this.versionCheck, 60000)
  },
  computed: {
    passExect() {
      if (this.newPass1) {
        return this.newPass1 == this.newPass2 ? true : 'パスワードが一致しません'
      } else {
        return true
      }
    },
    emailExect() {
      if (this.newEmail1) {
        return this.newEmail1 == this.newEmail2 ? true : 'メールアドレスが一致しません'
      } else {
        return true
      }
    },
  },
  watch: {
    
  },
  methods: {
    reload() {
      //更新
      location.reload(true)
    },
    move(path = '/') {
      this.$router.push(path)
    },
    //バージョンチェック
    async versionCheck() {
      //githubのリポジトリから最新バージョンを取得
      const params = {
        owner: 'takashi-fd3s-1308',
        repo: 'erp-v',
        branch: 'kinkagi',
        file: 'package.json',
        token: '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',
      }
      const res = await fetch(
        `https://api.github.com/repos/${params.owner}/${params.repo}/contents/${params.file}?ref=${params.branch}`,
        {
          headers: {
            authorization: `token ${params.token}`,
            accept: 'application/vnd.github.v3+json',
          }
        }
      )
      
      const data = await res.json()
      if (data.content) {
        const content = JSON.parse(Buffer.from(data.content, 'base64').toString())
        //バージョンチェック
        if (content.version != this.current_ver && location.hostname != 'localhost') {
          //メンテナンス画面表示
          this.mainte = true
          //サービスワーカーの削除
          window.navigator.serviceWorker.getRegistrations().then(registrations => {
            for(let registration of registrations) {
              registration.unregister()
            }
          })
          //バージョンチェック停止
          clearInterval(this.verCheck)
        }
      }
    },
    async logout() {
      try {
        await Auth.signOut()
        this.$router.push('/login')
      } catch (error) {
        console.log(error)
      }
    },
    async passChange() {
      if (confirm('パスワードを変更しますか？')) {
        try {
          //ユーザー情報
          const user = await Auth.currentAuthenticatedUser()
          //パスワードの変更
          await Auth.changePassword(user, this.oldPass, this.newPass1)
          //成功
          this.passDialog = false
          Object.keys(this.$refs).forEach(f => {
            if (this.$refs[f]) this.$refs[f].reset()
          })
          this.log({ type: '個人情報', text: 'パスワードを変更しました' })
          this.myAlert('パスワードを変更しました', 'success')

        } catch (error) {
          this.myAlert('パスワードを変更できませんでした')
        }
      }
    },
    async emailChange() {
      if (confirm('メールアドレスを変更しますか？')) {
        try {
          //ユーザー情報
          const user = await Auth.currentAuthenticatedUser()
          
          //パスワードの変更
          const ret = await Auth.updateUserAttributes(user, {
            email: this.newEmail1,
          })
          
          //成功
          if (ret == 'SUCCESS') {
            await API.graphql(graphqlOperation(updateUser, {input: {
              id: user.attributes.sub,
              email: this.newEmail1
            }}))
          } else {
            throw 'メールアドレスの変更に失敗'
          }
          
          this.emailDialog = false
          Object.keys(this.$refs).forEach(f => {
            if (this.$refs[f]) this.$refs[f].reset()
          })
          this.log({ type: '個人情報', text: 'メールアドレスを変更しました' })
          this.myAlert('メールアドレスを変更しました', 'success')

        } catch (error) {
          this.myAlert('メールアドレスを変更できませんでした')
        }
      }
    },
    //権限の取得
    async getRoles(nextToken = null) {
      const query = await API.graphql(graphqlOperation(listRoles, { limit: 100, nextToken: nextToken }))
      for (const data of query.data.listRoles.items) {
        this.roles.push(data)
        this.$store.dispatch('updateRoles', this.roles)
      }
      if (query.data.listRoles.nextToken) this.getRoles(query.data.listRoles.nextToken)
    },
  }
}
</script>

<style lang='scss' scoped>
.logo {
  cursor: pointer;
}
.mainte-mask {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, .7);
  z-index: 10;
  .wrap {
    color: #FFF;
    text-align: center;
    .message-main {
      font-size: 20px;
      font-weight: 600;
      margin: 20px 0;
    }
    .message-sub {
      font-size: 14px;
      margin-bottom: 20px;
    }
  }
}
</style>
